<div class="grid grid-nogutter mt-4">
  <div class="col-12">
    <p-table
      *ngIf="professionals.length"
      #dt
      id="scopen-offices-table"
      [value]="filteredProfessionals"
      [resizableColumns]="false"
      [scrollable]="false"
      selectionMode="single"
      [style]="{ width: '100%' }"
    >
      <ng-template pTemplate="caption">
        <div class="flex align-items-center justify-content-between">
          <p-selectButton
            [options]="enabledOptions"
            [(ngModel)]="selectedEnabledOptionValue"
            (onChange)="selectedEnabledOptionValueChanged()"
            optionLabel="label"
            optionValue="value"
            [multiple]="false"
          ></p-selectButton>
          <span class="p-float-label">
            <input
              id="float-input-professionals"
              type="text"
              pInputText
              [(ngModel)]="selectedSearchText"
              (ngModelChange)="searchTextChanged()"
              class="mr-2"
            />
            <label for="float-input-professionals">Search</label>
            <button
              type="button"
              pButton
              pRipple
              icon="pi pi-file-excel"
              (click)="exportExcel()"
              class="p-button-success mr-2"
              pTooltip="Export to Excel"
              tooltipPosition="bottom"
              label="Excel"
            ></button>
          </span>
        </div>
      </ng-template>

      <ng-template pTemplate="header" let-columns>
        <tr>
          <th i18n class="capitalize">current</th>
          <th i18n class="capitalize">title</th>
          <th pSortableColumn="person.firstName" i18n class="capitalize person-name">
            first name <p-sortIcon field="person.firstName"></p-sortIcon>
          </th>
          <th pSortableColumn="person.lastName" i18n class="capitalize person-name">
            last name <p-sortIcon field="person.lastName"></p-sortIcon>
          </th>
          <th pSortableColumn="positionName" i18n class="capitalize">
            position name <p-sortIcon field="positionName"></p-sortIcon>
          </th>
          <th pSortableColumn="role.name" i18n class="capitalize person-role">
            role <p-sortIcon field="role.name"></p-sortIcon>
          </th>
          <th i18n class="capitalize">phone</th>
          <th i18n class="capitalize">mobile phone</th>
          <th pSortableColumn="email" i18n class="capitalize">email <p-sortIcon field="email"></p-sortIcon></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-professional>
        <tr
          [className]="professional.role.id === 2 ? 'role-director' : ''"
          [pSelectableRow]="professional"
          (click)="navigateToPerson(professional)"
        >
          <td class="text-center">
            <i
              [ngClass]="{
                pi: true,
                'pi-check': professional.isActive,
                'pi-times': !professional.isActive
              }"
            ></i>
          </td>
          <td>
            {{ professional.person?.title?.name || '-' }}
          </td>
          <td>
            {{ professional?.person?.firstName || '-' }}
          </td>
          <td>
            {{ professional?.person?.lastName || '-' }}
          </td>
          <td>
            {{ professional.positionName || '-' }}
          </td>
          <td>
            {{ professional.role?.name || '-' }}
          </td>
          <td>
            {{ professional.parsedPhone() || '-' }}
          </td>
          <td>
            {{ professional.parsedMobilePhone() || '-' }}
          </td>
          <td>
            {{ professional?.email }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
